import { vappContainer } from '@/application';
import { BuyInsurancePageService } from '@pages/BuyInsurancePage/services';

const MODULE_NAME = 'BuyInsurancePage.machines.states.sendOTP';

const getSrv = () => {
  return vappContainer.get<BuyInsurancePageService>(
    BuyInsurancePageService.displayName
  );
};

export const sendOTP = async (context: any, event: any) => {
  const currentState = 'SEND_OTP';
  const method = 'sendOTP';

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      const content = await srv.agent.getSendOTPProps(event?.payload);
      if (content) {
        return resolve({
          key: 'SEND_OTP_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        return reject({
          key: 'SEND_OTP_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      return reject({
        key: 'SEND_OTP_FAILED',
        value: err?.message,
      });
    }
  });
};
